export default __webpack_public_path__ + "static/media/ee6bc2f9bdace98730ae3e35121451b7.71c0beee.jpg";